import { styled } from 'styled-components';

import { colors, cssBreakpoints } from '#/theme/theme';

export const CmsTwoTilesBlockTile_Box_1 = styled.div`
  margin-top: 32px;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 52px;
  }
`;

export const CmsTwoTilesBlockTile_Box_2 = styled.div`
  padding: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: stretch;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  text-align: center;
  border-radius: 7px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 0.1);
  background: ${colors.white};

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding: 60px;
  }

  &[data-second] {
    margin-top: 20px;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      margin-top: 0;
      margin-left: 40px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 10px;
    background-image: linear-gradient(
      to left,
      ${colors.skyBlue},
      ${colors.brandBlue}
    );
    background-size: 100% 10px;
    background-repeat: no-repeat;
  }
`;
